<!--suppress CommaExpressionJS -->
<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="subConfig.breadcrumb" />
    <!--<bread-crumb :breadcrumb="subConfig.breadcrumb" />-->
    <div class="rel">
      <text-title :mainTitle="subConfig.title[0]" :subheading="subConfig.title[1]" />
      <!--<title-bar :title="subConfig.title" />-->

      <div class="abs-right">
        <a v-if="subConfig.patchable !== false"
           class="revise margin-right-40" @click="showModify(data.code)">修改</a>
        <a class="revise" @click="$router.go(-1)">返回</a>
      </div>
    </div>
    <ul class="content">
      <li v-for="[key, {type, label}], index in this.keyMappingEntities" :key="index">
        <b class="content-label">{{label ? (label + '：') : ''}}</b>

        <img class="image" v-if="type && type.startsWith('icon-upload')"
             :src="data[key]" />
        <p class="value" v-else>{{data[key] || '暂无'}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import BreadCrumb from '../common/bread-crumb'
import diDingMixin from './di-ding-mixin'
import TitleBar from '../common/title-bar'
import {
  errorHandler,
  ifNullGenerateTipping
} from '../../../../utils/errorHandler'
import Breadcrumb from '../../../Breadcrumb/Breadcrumb'
import TextTitle from '../../../Text/TextTitle'

export default {
  components: {
    TextTitle,
    Breadcrumb,
    TitleBar,
    BreadCrumb
  },
  name: 'di-ding-current',
  mixins: [diDingMixin],
  data () {
    return {
      data: {},
      loading: true
    }
  },
  computed: {
    subConfig () {
      return this.config.current
    }
  },
  created () {
    this.render()
  },
  methods: {
    render () {
      this.getCurrent()
    },
    getCurrent () {
      const {id} = this.$route.params
      this.config.getCurrent(id)
        .then(ifNullGenerateTipping('未查询到当前项'))
        .then(this.onDataLoaded)
        .then(this.fetchDetail)
        .catch(errorHandler('请求失败'))
    },
    onDataLoaded (data) {
      this.keyMappingEntities.forEach(([key, {onDataLoaded}]) => {
        // 配置中的 onLoad
        onDataLoaded && onDataLoaded(data, 'current')
        // 针对表单的特殊处理
        const spData = data[`_${key}`]
        if (spData) {
          data[key] = spData._label
        }
      })
      this.data = data
    },
    fetchDetail () {
      const {data} = this
      this.keyMappingEntities.forEach(([key, {fetchDetail, onDetailLoaded}]) => {
        fetchDetail && fetchDetail()
          .then(list => {
            onDetailLoaded(data, list)
            // 针对表单的特殊处理
            const spData = data[`_${key}`]
            if (spData) {
              data[key] = spData._label
            }
          })
      })
    },
    showModify (id) {
      if (this.config.alsoPrint().routerPush) {
        this.config.routerPush.modify.call(this, id)
        return
      }
      this.routerPush('diDingModify', {
        diName: this.diName,
        id
      })
    }
  }
}
</script>

<style scoped lang="less">
  .main_right {
    text-align: left;
  }
  .abs-right {
    position: absolute;
    right: 35px;
    top: 2px
  }
  .abs-right a:hover {
    color: #1362FF;
  }
  .margin-right-40 {
    margin-right: 40px;
  }
  .content {
    width: 80%;
    margin: 0 auto;
    position: relative;
    li {
      line-height: 48px;
      overflow: hidden;
      padding-left: 40px;
    }
    .image {
      width: 64px;
      height: 64px;
      border: 5px solid #D7D7D7;
      margin-bottom: 10px;
      overflow: hidden;
    }
    .content-label {
      color: #48576A;
      font-weight: 400;
      display: inline-block;
      width: 128px;
      text-align: right;
      margin-right: 20px;
      vertical-align: top;
    }
    .value {
      color: #333333;
      font-weight: 400;
      display: inline-block;
      margin-right: 30px;
      width: 60%;
    }
    .revise {
      background-color: white;
      color: #1362FF;
      width: 30px;
      height: 20px;
      line-height: 20px;
      float: right;
      margin-right: 40px;
      cursor: pointer;
      &:hover {
        text-decoration: none;
        color: #337AB7;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/pages/current.vue